<template>

    <div class="m-auto px-8 md:px-20 pb-8">
        <ConfermaModal @confirm="riprendi" @reject="conferma_visible = false" :backdrop="true"
                       :visible="conferma_visible">
            Confermi di voler riprendere questa versione?
        </ConfermaModal>
        <div class="max-w-screen-2xl m-auto">
            <div class="flex justify-between">
                <h1 class="pt-10 text-2xl font-bold">
                    {{ sottoprogetto?.titolo }}
                </h1>
                <NextButton @click="conferma_visible = true" variant="outline-primary" class="self-center p-1">
                    Riprendi versione
                </NextButton>
            </div>
            <div class="flex items-center gap-3 py-4">
                <p class="text-sm"><i class="icon icon-flag text-next-orange"></i> Versione {{
                        sottoprogetto?.major
                    }}.{{ sottoprogetto?.minor }} create da <b>{{ sottoprogetto?.created_by_label }}</b> il
                    {{ $filters.toDate(sottoprogetto?.created_at) }} alle {{
                        $filters.toTime(sottoprogetto?.created_at)
                    }}</p>
                <BadgeStato :stato="sottoprogetto?.stato"></BadgeStato>
            </div>
            <SottoProgettoHead
                :budget="sottoprogetto?.budget ? `€ ${Number(sottoprogetto?.budget).toLocaleValueString()}` : '-'"
                :totaleRicavi="ActiveTab && TotaleRicaviProgetto(ActiveTab.sezioni) ? $filters.toEuroCurrency(TotaleRicaviProgetto(ActiveTab.sezioni)) : '-'"
                :budgetProgetto="ActiveTab && TotaleBudgetProgetto(ActiveTab.sezioni) ? $filters.toEuroCurrency(TotaleBudgetProgetto(ActiveTab.sezioni)) : '-'"
                :commissioni="ActiveTab && TotaleCommissioniProgetto(ActiveTab.sezioni) ? $filters.toEuroCurrency(TotaleCommissioniProgetto(ActiveTab.sezioni)) : '-'"
                :totaleCosti="ActiveTab && TotaleCostiEuroProgetto(ActiveTab.sezioni) ? $filters.toEuroCurrency(TotaleCostiEuroProgetto(ActiveTab.sezioni)) : '-'"
                :risorseInterne="dati && dati.risorse_interne ? dati.risorse_interne : '-'"
                :utile="ActiveTab && TotaleUtiliProgetto(ActiveTab.sezioni).toLocaleValueString() ? `€ ${TotaleUtiliProgetto(ActiveTab.sezioni).toLocaleValueString()}` : '-'"
                :margine="ActiveTab && TotaleMolFee(ActiveTab.sezioni) ? `${TotaleMolFee(ActiveTab.sezioni).toLocaleValueString()} %` : '-'"
                :fee="ActiveTab && TotaleFeesSezioni(ActiveTab.sezioni) ? TotaleFeesSezioni(ActiveTab.sezioni).toLocaleValueString() : '-'"
            ></SottoProgettoHead>

            <Tabs class="py-8" :tabs="dati?.tabs" v-model="dati.active_tab" readonly></Tabs>

            <template v-if="ActiveTab">
                <div class=" overflow-x-scroll">
                    <SezioneSottoProgetti
                        readonly
                        v-model:titolo="s.titolo" v-for="(s,i) in ActiveTab.sezioni"
                        :key="s.titolo + i"
                        :order="i+1"
                        :last="i === s.length-1"
                        :first="i === 0"
                        v-model:expanded="s.expanded"
                        :hideTotal="true"
                    >
                        <NextSottoProgettoTable class="w-full border-separate py-4"
                                                actionClass="relative"
                                                :cols="tableHeader"
                                                :rows="s.ordered_records">
                            <template v-for="(rc, x) in rowCellIterator(s.ordered_records, sottoProgettiCols)"
                                      :key="x"
                                      v-slot:[`td_${rc}`]="{row, cell}">
                                <span class="h-10 flex items-center w-full"
                                      v-bind="getProps(row, cell)">
                                    {{ getValue(row, cell) }}
                                </span>
                            </template>
                        </NextSottoProgettoTable>
                    </SezioneSottoProgetti>
                </div>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import Topbar from "../components/Topbar.vue";
import InfiniteLoading from "v3-infinite-loading";
import ContextMenu from "@/components/ContextMenu.vue";
import ModalSottoProgetto from "@/components/ModalSottoProgetto.vue";
import NextSottoProgettoTable from "@/components/NextSottoProgettoTable.vue";
import SezioneSottoProgetti from "@/components/SezioneSottoProgetti.vue";
import ModalEsportaSottoprogetto from "@/components/EsportaSottoprogetto.vue";
import versioniSottoProgettiManager from "../api/SottoProgettiVersione";
import BadgeStato from "@/components/BadgeStato.vue";
import SottoProgettoHead from "@/views/SottoProgettoHead.vue";
import {mapActions, mapGetters, mapState} from 'vuex';
import Tabs from "@/components/Tabs.vue";
import DynamicCell from "@/components/DynamicCell.vue";
import Empty from "@/components/Empty.vue";
import NextButton from "@/components/NextButton.vue";
import sottoProgettiVersione from "../api/SottoProgettiVersione";
import ConfermaModal from "@/components/ConfermaModal.vue";
import sottoProgettiManager from "../api/SottoProgetti";

@Options({
    name: 'DettaglioVersioneSottoProgetto',
    components: {
        ConfermaModal,
        NextButton,
        DynamicCell,
        Tabs,
        SottoProgettoHead,
        BadgeStato,
        Topbar,
        NextSottoProgettoTable,
        ContextMenu,
        InfiniteLoading,
        ModalSottoProgetto,
        ModalEsportaSottoprogetto,
        SezioneSottoProgetti,
    },
    props: {
        id: String,
        idv: String,
    },
    computed: {
        ...mapState('buFieldModule', {
            sottoProgettiCols: (state: any) => state.sottoProgettiCols
        }),
        ...mapGetters('buFieldModule', [
            'tableHeader'
        ]),
        ...mapGetters('sprjDataManager', [
            'AcCostoUnitarioNetto',
            'AcCostoTotale',
            'AcCostoTotaleEuro',
            'VeBudget',
            'VeBudgetEuro',
            'BudgetLordoIva',
            'Utile',
            'CostoVenditaUnitario',
            'Mol',
            'TotaleCostiEuroProgetto',
            'TotaleBudgetProgetto',
            'TotaleUtiliProgetto',
            'TotaleCommissioniProgetto',
            'TotaleRicaviProgetto',
            'TotaleMol',
            'TotaleMolFee',
            'TotaleFeesSezioni',
        ]),
    },
    methods: {
        ...mapActions('buFieldModule', [
            'setAllVisible',
        ]),
        ...mapActions('sprjDataManager', [
            'setValute',
            'setFees',
            'setSottoprogetto',
            'setDatiSottoprogetto',
            'setFees',
        ])
    }
})
export default class DettaglioVersioneSottoProgetto extends Vue {

    id!: number | string
    idv!: number | string
    topbar = Topbar
    loading = false
    conferma_visible = false
    tableHeader: any
    setAllVisible: any
    sottoprogetto = {
        sottoprogetto_id: '',
        stato: null
    }
    private sottoProgettiCols: any;

    AcCostoUnitarioNetto: any
    AcCostoTotale: any
    AcCostoTotaleEuro: any
    VeBudget: any
    VeBudgetEuro: any
    TotaleMolFee: any
    TotaleCommissioniProgetto: any
    TotaleBudgetProgetto: any
    BudgetLordoIva: any
    TotaleFeesSezioni: any
    Utile: any
    CostoVenditaUnitario: any
    Mol: any
    setDatiSottoprogetto: any
    setFees: any

    dati = {
        fee: [],
        rebate: [],
        valute: [],
        budget_consuntivo: 0,
        totale_costi: 0,
        risorse_interne: 0,
        totale_ricavi: 0,
        utile: 0,
        margine: 0,
        active_tab: 0,
        tabs: [
            {
                titolo: 'Nuovo tab',
                sezioni: [
                    {
                        titolo: '',
                        expanded: true,
                        records: [{}],
                        ordered_records: [{}]
                    },
                ]
            },
        ]
    }

    riprendi() {
        sottoProgettiVersione.riprendiVersione(this.idv).then((res) => {
            //@ts-ignore
            this.$router.replace({name: 'DettaglioSottoProgetto', params: {id: res.data.sottoprogetto_id}})
        })
    }

    mounted() {
        versioniSottoProgettiManager.versione(this.idv).then((res) => {
            this.setAllVisible()
            this.sottoprogetto = res.data
            this.dati = {...this.dati, ...JSON.parse(res.data.data)}
            this.setFees(this.dati.fee)
            this.setDatiSottoprogetto(this.dati)
            return sottoProgettiManager.gamma(this.sottoprogetto.sottoprogetto_id)
        }).then((res_gamma: any) => {
            this.sottoprogetto.stato = res_gamma.data.PD0C_STATO_PD1E
        })
    }

    get ActiveTab() {
        if (this.dati) {
            // @ts-ignore
            return this.dati.tabs[this.dati.active_tab]
        }
        return null
    }

    hasNuvole(row: any) {
        return row.nuvole
    }

    getComponent(row: any, cell: any) {
        return 'Text'
    }

    getProps(row: any, cell: any) {

        if (this.hasNuvole(row)) {
            switch (cell.prop) {
                case 'ne_descrizione_servizio':
                    return {
                        type: 'text',
                        class: ''
                    }
                default:
                    return Empty
            }
        }
        switch (cell.prop) {
            case 'ne_titolo':
                return {
                    type: 'text',
                    class: 'bg-white'
                }
            case 'ne_descrizione_servizio':
                return {
                    type: 'text',
                    class: 'bg-white'
                }
            case 'ne_fornitore':
                return {
                    class: "absolute inset-0 bg-white",
                }
            case 'ne_stato':
            case 'ne_voce_spesa':
                return {
                    class: "absolute inset-0 bg-white",
                }
            case 'ac_unita_descrizione':
            case 'ac_ovn_gg_descrizione':
            case 'ac_qta_descrizione':
            case 'ac_costo_unitario_netto':
            case 'ac_costo_totale':
            case 'ac_costo_unitario_e':
            case 'ac_costo_totale_e':
                return {
                    type: 'text',
                    disabled: 'true',
                    class: 'bg-next-acquisto text-right'
                }
            case 'ac_costo_unitario':
            case 'ac_costo_unitario_risorsa_interna':
            case 'ac_costo_totale_risorsa_interna':
            case 've_costo_unitario':
                return {
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'bg-next-acquisto text-right'
                }
            case 'ac_unita':
                return {
                    min: 0,
                    type: 'number',
                    step: '1',
                    class: 'bg-next-acquisto'
                }
            case 've_budget':
            case 've_budget_e':
            case 've_budget_lordo_iva':
                return {
                    disabled: true,
                    class: 'bg-next-vendita text-right'
                }
            case 've_unita':
                return {
                    min: 0,
                    type: 'number',
                    step: '1',
                    class: 'bg-next-vendita'
                }
            case 'ac_ovn_gg':
            case 'ac_qta':
            case 'ac_totale_commissioni':
                return {
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'bg-next-acquisto'
                }
            case 've_ovn_gg':
            case 've_qta':
            case 've_totale_commissioni':
                return {
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'bg-next-vendita'
                }
            case 'ac_commissione':
                return {
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'bg-next-acquisto'
                }
            case 'ac_valuta':
            case 'ac_aliquota':
                return {
                    class: "absolute inset-0 bg-next-acquisto",
                }
            case 've_valuta':
            case 've_aliquota':

                return {
                    class: "absolute inset-0 bg-next-vendita",
                }
            case 'ac_mark_up':
                return {
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'bg-next-acquisto'
                }
            case 'ac_arrotondamento_costo_unitario':
                return {
                    min: 0,
                    type: 'number',
                    step: '1',
                    class: 'bg-next-acquisto w-full'
                }
            case 'ac_note_interne':
                return {
                    class: 'bg-next-acquisto w-full'
                }
            case 've_unita_descrizione':
            case 've_ovn_gg_descrizione':
            case 've_qta_descrizione':
            case 've_note':
            case 've_storico':
                return {
                    class: 'bg-next-vendita w-full'
                }
            case 've_vendita_unitario':
            case 've_costo_unitario_risorsa_interna':
            case 've_costo_totale_risorsa_interna':
                return {
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'bg-next-vendita text-right'
                }
            case 're_mol':
                return {
                    disabled: true,
                    type: 'text',
                    class: 'bg-next-margine'
                }
            case 've_fee':
            case 're_utile':
                return {
                    disabled: true,
                    type: 'text',
                    class: 'bg-next-margine text-right'
                }
            default:
                return {
                    // value: row[cell.prop]
                }
        }
    }

    getValue(row: any, cell: any) {
        let value: any;
        switch (cell.prop) {
            case 'ac_costo_unitario_netto':
                return this.AcCostoUnitarioNetto(row).toCurrencyString()
            case 'ac_costo_totale':
                return this.AcCostoTotale(row).toCurrencyString()
            case 'ac_costo_totale_e':
                return this.AcCostoTotaleEuro(row).toCurrencyString()
            case 've_budget':
                return this.VeBudget(row).toCurrencyString()
            case 've_budget_e':
                return this.VeBudgetEuro(row).toCurrencyString()
            case 've_budget_lordo_iva':
                return this.BudgetLordoIva(row).toCurrencyString()
            case 're_utile':
                return this.Utile(row).toCurrencyString()
            case 've_vendita_unitario':
                return this.CostoVenditaUnitario(row)
            case 're_mol':
                // eslint-disable-next-line no-case-declarations
                const v = this.Mol(row)
                return `${(v ? v : 0).toCurrencyString() || ''} %`
            case 'ac_valuta':
            case 've_valuta':
                value = this.dati.valute.find((el: any) => el.id == row[cell.prop])
                return value?.descrizione
            case 'ne_fornitore':
                value = row[cell.prop]
                return value?.denominazione
            case 'ne_voce_spesa':
            case 'ne_stato':
            case 'ac_aliquota':
            case 've_aliquota':
            case 've_fee':
                value = row[cell.prop]
                return value?.descrizione
        }
        return row[cell.prop]
    }

    rowCellIterator(righe: any[], colonne: any[]) {
        const res = []
        for (let i in righe) {
            for (let j in colonne) {
                res.push(`${i}_${colonne[j].prop}`)
            }
        }
        return res
    }
}


</script>


<style lang="scss">

</style>
